import * as React from 'react'
import { Navigate } from 'react-router-dom'
import authStore from '../store/authStore.ts'
import dataStore from '../store/dataStore.ts'

interface Props {
    children: React.ReactNode
}

export const ProtectedRoute: React.FC<Props> = ({ children }) => {
    // Subscribe to the token so route decisions re-evaluate on logout / expiry
    const token = authStore(s => s.token)

    // Clear stores when unauthenticated — as a side effect, not during render
    React.useEffect(() => {
        if (!token) {
            authStore.getState().reset()
            dataStore.getState().reset()
        }
    }, [token])

    if (!token) {
        return <Navigate to="/" replace />
    }

    return <>{children}</>
}
